// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.extension-chooser_modal-content_bkZcx.extension-chooser_full-screen_tEAo5 {
    overflow-y: hidden !important;
}

.extension-chooser_container_sEr7c {
    display: flex;
    flex-direction: column;
    padding: 2rem;
}

.extension-chooser_header_XSBIQ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
}

.extension-chooser_title_azhbd {
    margin: 0;
    font-size: 2rem;
    font-weight: bold;
}

.extension-chooser_openLibraryButton_vxvhP, .extension-chooser_openCustomExtension_NW7D1, .extension-chooser_openCodeButton_bUd6b{
    justify-content: center;
    background-color: var(--looks-secondary);
    border: none;
    border-radius: 2000px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    transition: filter 0.2s ease-in-out;
    position: absolute;
    bottom: 30px;
    overflow: hidden;
    display: flex;
    align-items: center;
    z-index: 1000;
}

.extension-chooser_openCustomExtension_NW7D1 {
    bottom: 100px;
    font-size: 16px;
}

.extension-chooser_openCodeButton_bUd6b{
    bottom: 170px;
    font-size: 16px;
}

.extension-chooser_openLibraryButton_vxvhP:hover, .extension-chooser_openCustomExtension_NW7D1:hover, .extension-chooser_openCodeButton_bUd6b:hover {
    filter: brightness(1.2);
}

.extension-chooser_content_Qqa_n {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: auto;
    max-height: calc(100vh - 115px - var(--stage-fullscreen-top));   
    width: 100%;
}

.extension-chooser_ExtTitle_sc4DN {
    font-size: x-large;
    font-weight: bold;
    margin-left: 10px;
    color: white
}

.extension-chooser_ExtId_mJljF {
    margin-left: 10px;
    color: white
}

.extension-chooser_Extbg_K4vgg {
    margin: 10px auto;
    width: 90%;
    min-height: 105px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 10px;
    overflow: hidden;
}

.extension-chooser_manages_JG8sS {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: 0;
}

.extension-chooser_button_KI4aA {
    font-family: inherit;
    font-size: 14px;
    background-color: white;
    border: none;
    padding: 0.5rem 1rem;
    margin: 0 5px;
    border-radius: 4px;
    cursor: pointer;
    font-family: inherit;
    font-weight: bold;
}

.extension-chooser_button_KI4aA:active,
.extension-chooser_button_KI4aA:focus-within {
    box-shadow: 0 0 0 3px var(--looks-transparent);
}

.extension-chooser_openLibraryButtonIcon_YzNT_ {
    width: 16px;
    height: 16px;
}

@media (max-width: 768px) {
    .extension-chooser_openLibraryButton_vxvhP, .extension-chooser_openCustomExtension_NW7D1 {
        position: fixed;
        left: 20px;
        width: 65px;
        height: 65px;
        z-index: 1000;
    }
    
    .extension-chooser_openLibraryButton_vxvhP {
        bottom: 100px;
    }
    
    .extension-chooser_openCustomExtension_NW7D1 {
        bottom: 20px;
    }
    
    .extension-chooser_openLibraryButtonIcon_YzNT_ {
        width: 24px;
        height: 24px;
    }
    
    .extension-chooser_content_Qqa_n {
        padding-bottom: 180px;
    }
    /*koshino我喜欢你喵~*/
}
`, "",{"version":3,"sources":["webpack://./src/components/extension-chooser/extension-chooser.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,6DAA6D;IAC7D,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;QACf,UAAU;QACV,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;IACA,gBAAgB;AACpB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content.full-screen {\n    overflow-y: hidden !important;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    padding: 2rem;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.title {\n    margin: 0;\n    font-size: 2rem;\n    font-weight: bold;\n}\n\n.openLibraryButton, .openCustomExtension, .openCodeButton{\n    justify-content: center;\n    background-color: var(--looks-secondary);\n    border: none;\n    border-radius: 2000px;\n    width: 50px;\n    height: 50px;\n    cursor: pointer;\n    transition: filter 0.2s ease-in-out;\n    position: absolute;\n    bottom: 30px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    z-index: 1000;\n}\n\n.openCustomExtension {\n    bottom: 100px;\n    font-size: 16px;\n}\n\n.openCodeButton{\n    bottom: 170px;\n    font-size: 16px;\n}\n\n.openLibraryButton:hover, .openCustomExtension:hover, .openCodeButton:hover {\n    filter: brightness(1.2);\n}\n\n.content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    overflow-y: auto;\n    max-height: calc(100vh - 115px - var(--stage-fullscreen-top));   \n    width: 100%;\n}\n\n.ExtTitle {\n    font-size: x-large;\n    font-weight: bold;\n    margin-left: 10px;\n    color: white\n}\n\n.ExtId {\n    margin-left: 10px;\n    color: white\n}\n\n.Extbg {\n    margin: 10px auto;\n    width: 90%;\n    min-height: 105px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    overflow: hidden;\n}\n\n.manages {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    min-height: 0;\n}\n\n.button {\n    font-family: inherit;\n    font-size: 14px;\n    background-color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    margin: 0 5px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-family: inherit;\n    font-weight: bold;\n}\n\n.button:active,\n.button:focus-within {\n    box-shadow: 0 0 0 3px var(--looks-transparent);\n}\n\n.openLibraryButtonIcon {\n    width: 16px;\n    height: 16px;\n}\n\n@media (max-width: 768px) {\n    .openLibraryButton, .openCustomExtension {\n        position: fixed;\n        left: 20px;\n        width: 65px;\n        height: 65px;\n        z-index: 1000;\n    }\n    \n    .openLibraryButton {\n        bottom: 100px;\n    }\n    \n    .openCustomExtension {\n        bottom: 20px;\n    }\n    \n    .openLibraryButtonIcon {\n        width: 24px;\n        height: 24px;\n    }\n    \n    .content {\n        padding-bottom: 180px;\n    }\n    /*koshino我喜欢你喵~*/\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `extension-chooser_modal-content_bkZcx`,
	"modalContent": `extension-chooser_modal-content_bkZcx`,
	"full-screen": `extension-chooser_full-screen_tEAo5`,
	"fullScreen": `extension-chooser_full-screen_tEAo5`,
	"container": `extension-chooser_container_sEr7c`,
	"header": `extension-chooser_header_XSBIQ`,
	"title": `extension-chooser_title_azhbd`,
	"openLibraryButton": `extension-chooser_openLibraryButton_vxvhP`,
	"openCustomExtension": `extension-chooser_openCustomExtension_NW7D1`,
	"openCodeButton": `extension-chooser_openCodeButton_bUd6b`,
	"content": `extension-chooser_content_Qqa_n`,
	"ExtTitle": `extension-chooser_ExtTitle_sc4DN`,
	"extTitle": `extension-chooser_ExtTitle_sc4DN`,
	"ExtId": `extension-chooser_ExtId_mJljF`,
	"extId": `extension-chooser_ExtId_mJljF`,
	"Extbg": `extension-chooser_Extbg_K4vgg`,
	"extbg": `extension-chooser_Extbg_K4vgg`,
	"manages": `extension-chooser_manages_JG8sS`,
	"button": `extension-chooser_button_KI4aA`,
	"openLibraryButtonIcon": `extension-chooser_openLibraryButtonIcon_YzNT_`
};
export default ___CSS_LOADER_EXPORT___;
